export default "__VITE_ASSET__b87ce3cb__"